import React from "react";
import { RenderLeafProps, useSlateStatic } from "slate-react";

import { Link } from "./renderer";

export const RichTextLeaf = ({ attributes, children, leaf }: RenderLeafProps) => {
    const editor = useSlateStatic();

    if (leaf.bold) {
        children = <strong>{children}</strong>;
    }
    if (leaf.code) {
        children = <code>{children}</code>;
    }
    if (leaf.italic) {
        children = <i>{children}</i>;
    }
    if (leaf.underline) {
        children = <u>{children}</u>;
    }
    if (leaf["strike-through"]) {
        children = <s>{children}</s>;
    }
    if (leaf.link) {
        children = (
            <Link href={leaf.link} text={leaf.text} editor={editor} isReadOnly={false}>
                {children} {/* mandatory, useless */}
            </Link>
        );
    }

    return <span {...attributes}>{children}</span>;
};

export default RichTextLeaf;
